import React from 'react';

export default class PrintView extends React.Component {
    getEventDate = () => {
        return `${this.props.eventDate.getMonth() + 1}/${this.props.eventDate.getDate()}/${this.props.eventDate.getFullYear()}`;
    }

    getSortedSchedule = () => {
        const schedule = [];
        for (const key in this.props.schedule) {
            schedule.push(this.props.schedule[key]);
        }

        return schedule.sort((a, b) => {
            return a.coaching_timestamp > b.coaching_timestamp ? 1 : (
                a.coaching_timestamp < b.coaching_timestamp ? -1 : 0
            );
        });
    }

    render() {
        const eventDate = this.getEventDate();
        const schedule = this.getSortedSchedule();

        return (
            <div>
                <h1>Kagan Coaching Schedule</h1>
                <h3>{ this.props.schoolName }</h3>
                <h3>{ eventDate }</h3>
                <p>{ this.props.note }</p>
                <table style={ { width: '100%' } }>
                    <thead>
                        <tr>
                            <th>Teacher Name</th>
                            <th>E-Mail</th>
                            <th>Structure</th>
                            { this.props.eventDates.length > 1 ? <th>Date</th> : null }
                            <th>Time</th>
                            <th>Room</th>
                            <th>Grade</th>
                            <th>Subject</th>
                            <th>Building</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            schedule.map(sch => (
                                <ScheduleRow
                                    key={ sch.id }
                                    { ...this.props }
                                    schedule={ sch } />
                            ))
                        }
                    </tbody>
                </table>
            </div>
        );
    }
}

class ScheduleRow extends React.Component {
    render() {
        const { schedule, eventDates } = this.props;
        const structure = this.props.structuresById[schedule.structure_id] || '';

        return (
            <tr>
                <td>{ schedule.first_name } { schedule.last_name }</td>
                <td>{ schedule.email_address }</td>
                <td>{ structure }</td>
                { eventDates.length > 1 ? <td>{ schedule.coaching_date }</td> : null }
                <td>{ schedule.coaching_time }</td>
                <td>{ schedule.room_number }</td>
                <td>{ schedule.grade_level }</td>
                <td>{ schedule.subject }</td>
                <td>{ schedule.topic }</td>
            </tr>
        );
    }
}